<!-- PAGE HEADER -->
@if (project && !notFound) {
<div class="hub-record-view-container">
    <div class="record-view-header">
        <div class="record-header-content">
            <div class="page-title d-flex">
                <h4>
                    <span class="font-weight-semibold text-success-800">View {{ project?.projectType?.name}} Record</span>
                    <span class="bg-teal-300 ml-2 p-1">ID: {{project?.projectId}}</span>
                </h4>
            </div>
            <div class="header-elements text-center text-md-left mb-3 mb-md-0">
                <div style="display: flex; justify-content: space-between">
                    <a
                        matTooltip="Email Link"
                        matTooltipShowDelay="500"
                        style="margin-left: 200px"
                        href="mailto:?subject={{ project?.projectType?.name }} - {{ project?.name }}&body={{getLocation()}}"
                        class="button"
                    >
                        <i class="icon-envelop3"></i>
                    </a>
                    @if (!isFavoritesBusy) {
                    <a href="#" class="button" (click)="toggleFavorite(project.projectId, $event)" matTooltipShowDelay="500" matTooltip="Add/Remove Favorite">
                        @if (userDataService.isFavorite(project?.projectId)) {
                        <span class="material-icons">favorite</span>
                        } @if (!userDataService.isFavorite(project?.projectId)) {
                        <span class="material-icons">favorite_border</span>
                        }
                    </a>
                    } @if (isFavoritesBusy) {
                    <a class="button">
                        @if (userDataService.isFavorite(project?.projectId)) {
                        <mat-spinner [diameter]="14"></mat-spinner>
                        } @if (!userDataService.isFavorite(project?.projectId)) {
                        <mat-spinner [diameter]="14"></mat-spinner>
                        }
                    </a>
                    }
                    <app-add-project-to-collection-button
                        [projectId]="project.projectId"
                        [projectName]="project.name"
                        [isButton]="true">
                    </app-add-project-to-collection-button>
                    <a matTooltip="View Change Log" matTooltipShowDelay="500" href="javascript:void(0)" (click)="showChangeLog()" class="button">
                        <span class="material-icons">receipt</span>
                    </a>
                    @if (authService.isAllowedToEdit(project)) {
                    <a matTooltip="Edit Record" matTooltipShowDelay="500" routerLink="edit" class="button">
                        <span class="material-icons">edit</span>
                    </a>
                    }
                </div>
            </div>
        </div>
    </div>
    <!-- SECTION LINKS -->
    <div class="section-links-container">
        <div class="show-hide-button">
            <a href="javascript: void(0)" (click)="toggleSectionLinks()">{{areSectionLinksShowing ? 'Hide' : 'Show'}} Section Links</a>
        </div>
        <div class="section-links-panel hub-custom-scrollbar" id="SectionLinks" [ngClass]="{'not-showing': !areSectionLinksShowing}">
            <div class="section-links-content">
                <h3>Section Links</h3>
                <div class="section-links">
                    <div class="section-link">
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('')"
                            fragment="relations"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Summary
                        </a>
                    </div>
                    <div class="section-link">
                        @if (isStrategy) {
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('strategicPillars')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Strategic Pillars
                        </a>
                        }
                    </div>
                    <div class="section-link">
                        @if (!isWholeSystem && !isProgramManagement) {
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('outcomes')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Outcomes
                        </a>
                        }
                    </div>
                    <div class="section-link">
                        @if (!isWholeSystem && !isProgramManagement) {
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('intermediateResults')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Intermediate Results
                        </a>
                        }
                    </div>
                    <div class="section-link">
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('outputs')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Outputs
                        </a>
                    </div>
                    <div class="section-link">
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('financials')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Financials
                        </a>
                    </div>
                    <div class="section-link">
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('partners')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Partnerships
                        </a>
                    </div>
                    <div class="section-link">
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('location')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Location
                        </a>
                    </div>
                    <!--HIDE IF NO ADDITIONAL INFORMATION EXISTS ON THE RECORD  -->
                    @if (!!project && (project.projectDonorKeywords.length || project.projectInstrumentTaxonomies.length)) {
                    <div class="section-link">
                        @if (!isProgramManagement) {
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('attributes')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Additional Information
                        </a>
                        }
                    </div>
                    }
                    <!--HIDE IF NO ASSOCIATED FILES / LINKS EXISTS ON THE RECORD  -->
                    @if (project?.projectLinks.length > 0) {
                    <div class="section-link">
                        <a
                            href="javascript:void(0)"
                            (click)="scrollIntoView('associatedFiles')"
                            class="list-group-item list-group-item-action text-primary legitRipple"
                        >
                            <i class="icon-bookmark2 mr-2"></i>
                            Associated Files
                        </a>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    <!-- TEAM MEMBERS -->
    <div class="team-container">
        <div class="show-hide-button">
            <a href="javascript: void(0)" (click)="toggleShowTeam()">{{isTeamShowing ? 'Hide' : 'Show'}} Team</a>
        </div>
        <div class="team-panel hub-custom-scrollbar" [ngClass]="{'not-showing': !isTeamShowing}" id="TeamMembers">
            <app-team-container [project]="project"></app-team-container>
        </div>
    </div>
    <!-- CONTENT -->
    <div class="record-content hub-custom-scrollbar" id="MainContentSection">
        <h2 class="d-block sb-b m-0 pb-1 ml-1 pl-2">
            <span class="font-weight-bold text-success-800">{{ project?.name }}</span>
            <span class="text-muted ml-1">({{ project?.status?.name }})</span>
        </h2>
        <app-summary-container [project]="project"></app-summary-container>
        @if (isStrategy) {
        <app-strategic-pillar-container [strategicPillars]="project?.projectStrategicPillars"></app-strategic-pillar-container>
        } @if (!isWholeSystem && !isProgramManagement) {
        <app-outcomes-container (projectDataAreLoading)="projectDataAreLoading($event)" [project]="project"></app-outcomes-container>
        } @if (!isWholeSystem && !isProgramManagement) {
        <app-intermediate-results-container [project]="project" (projectDataAreLoading)="projectDataAreLoading($event)"></app-intermediate-results-container>
        }
        <app-outputs-container [projectTypeName]="project.projectType.name" [outputs]="project?.outputs"></app-outputs-container>
        <app-financials-container [project]="project"></app-financials-container>
        <app-partners-container [project]="project"></app-partners-container>
        <app-location-container [project]="project"></app-location-container>
        @if (!isProgramManagement) {
        <app-attributes-container
            [project]="project"
            [setAttributes]="project?.projectInstrumentTaxonomies"
            [setDonorKeywords]="project?.projectDonorKeywords"
        ></app-attributes-container>
        }
        <app-associated-files-container [links]="project?.projectLinks"></app-associated-files-container>
    </div>
</div>
} @if (notFound) {
<app-not-found></app-not-found>
} @if (isBusy) {
<app-modal-spinner></app-modal-spinner>
}
